export const REDEEM_REGEX_16 = /[A-Z0-9]{16}/i;
export const REDEEM_REGEX_4 =
  /[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}/i;
export const REDEEM_REGEX_15 = /[A-Z0-9]{15}/i;
export const REDEEM_REGEX_14 = /[A-Z0-9]{14}/i;
export const REDEEM_REGEX_12 = /[A-Z0-9]{12}/i;
export const REDEEM_REGEX_3 = /[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}/i;
